var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterTwoMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2502 1.02354L1.43651 4.9142C1.31892 4.94635 1.2141 5.01397 1.13633 5.10784C1.05855 5.20171 1.01161 5.31728 1.00189 5.4388C0.992167 5.56031 1.02014 5.68187 1.082 5.78692C1.14386 5.89196 1.2366 5.97538 1.34758 6.02582L7.69121 9.02718C7.81547 9.08473 7.91527 9.18453 7.97282 9.30879L10.9742 15.6524C11.0246 15.7634 11.108 15.8561 11.2131 15.918C11.3181 15.9799 11.4397 16.0078 11.5612 15.9981C11.6827 15.9884 11.7983 15.9414 11.8922 15.8637C11.986 15.7859 12.0537 15.6811 12.0858 15.5635L15.9765 1.7498C16.0059 1.64899 16.0078 1.54212 15.9817 1.44036C15.9557 1.33861 15.9028 1.24574 15.8285 1.17147C15.7543 1.09721 15.6614 1.04429 15.5596 1.01826C15.4579 0.992235 15.351 0.994058 15.2502 1.02354V1.02354Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwoMail);
export default __webpack_public_path__ + "static/media/footer-two-mail.11de40925a1b582934be4224915be669.svg";
export { ForwardRef as ReactComponent };